module.exports = __webpack_public_path__ + "img/Motor_sus_1.cef14866.jpg";